module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoading) ? _c('el-dialog', {
    attrs: {
      "visible": _vm.popup,
      "size": "tiny",
      "before-close": _vm.close,
      "i": "base_vip"
    },
    on: {
      "update:visible": function($event) {
        _vm.popup = $event
      }
    }
  }, [_vm._l((_vm.list), function(d, index) {
    return [(_vm.level === d.level) ? _c('div', {
      key: index,
      staticClass: "content",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "i": "content"
      },
      domProps: {
        "innerHTML": _vm._s(d.value2)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.level === d.level == 1) ? _c('div', {
      key: index + 's',
      staticClass: "code"
    }, [_c('div', {
      staticClass: "box clearfix"
    }, [_c('div', {
      staticClass: "img-box pull-left"
    }, [(d.qrcode) ? _c('img', {
      attrs: {
        "src": d.qrcode
      }
    }) : _vm._e(), (_vm.over) ? _c('p', {
      staticClass: "text-center"
    }, [_vm._v("二维码已过期")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "cont pull-left"
    }, [_c('p', [_vm._v("请使用微信支付")]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v(_vm._s(_vm._f("toPrice")(d.value)) + "元/年")])])]), _vm._v(" "), _c('p', [_vm._v("会员到期时间" + _vm._s(_vm._f("timeDate")(d.validity_time)))])]) : _vm._e()]
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a8dae26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vip.vue
// module id = 1023
// module chunks = 59